<template>
  <div class="devProject-content__wrapper">
    <div class="devProject-content__container">
      <div class="devProject-content__poster-container">
        <img class="devProject-content__poster" :src="posterVideo" alt="" />
      </div>
      <div class="devProject-content__devices-container">
        <div class="devProject-content__devices-animation-block"></div>
        <div class="devProject-content__second-phone">
          <img :src="secondPhone" alt="" />
        </div>
        <div class="devProject-content__laptop-container">
          <img class="devProject-content__laptop-img" :src="laptop" alt="" />
          <video
            muted
            loop
            playsinline
            autoplay
            class="devProject-content__laptop-video"
            :src="laptopVideo"
            type="video/mp4"
          />
        </div>
      </div>
    </div>
    <div class="devProject-content-mob__wrapper">
      <img class="devProject-content-mob__br" :src="brForPhone" alt="" />
      <div class="devProject-content-mob__container">
        <video
          muted
          loop
          playsinline
          autoplay
          class="devProject-content-mob__phone-video"
          :src="phoneVideo"
          type="video/mp4"
        />
        <img class="devProject-content-mob__phone" :src="phone" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";

gsap.registerPlugin(ScrollTrigger);

export default {
  props: [
    "posterVideo",
    "firstPhone",
    "secondPhone",
    "laptopVideo",
    "phoneVideo",
  ],
  data() {
    return {
      laptop: require("@/assets/images/projectsPage/laptop.png"),
      brForPhone: require("@/assets/images/projectsPage/brForPhone.png"),
      phone: require("@/assets/images/projectsPage/phone.png"),
      tl: null,
    };
  },
  mounted() {
    this.tl = gsap.timeline();
    this.tl.fromTo(
      ".devProject-content__second-phone",
      { opacity: 0, yPercent: 50 },
      {
        scrollTrigger: {
          trigger: ".devProject-content__devices-container",
          start: "50% 100%",
          end: "50% 70%",
          scrub: 2,
          // markers: true,
        },
        opacity: 1,
        yPercent: 0,
      }
    );
  },
  beforeUnmount() {
    this.tl.kill();
    this.tl = null;
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/grid/grid";

.devProject-content__wrapper {
  width: 100%;
  overflow: hidden;
}
.devProject-content__container {
  display: flex;
  flex-direction: column;
  @include myAdaptiv-row-gap(130, 80);

  max-width: 1260px;
  width: 100%;

  margin: 0 auto;
}
.devProject-content__poster-container {
  position: relative;

  width: 100%;
  padding-top: 56.14%;

  @include myAdaptivMargin(120, 0, 0, 0, 100, 0, 0, 0);
}
.devProject-content__poster {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
}

.devProject-content__devices-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding-top: 62%;

  @include myAdaptivMargin(0, 0, 150, 0, 0, 0, 50, 0);
}
.devProject-content__first-phone {
  position: absolute;
  top: 18.8%;
  left: 0;

  width: 17.5%;
  height: 61.7%;

  z-index: 1;
}
.devProject-content__second-phone {
  position: absolute;
  top: 30%;
  right: 7%;

  width: 15.3%;
  height: 49.6%;

  z-index: 1;
}
.devProject-content__laptop-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  width: 90%;
  height: 90%;
}
.devProject-content__laptop-img {
  width: 100%;
  height: 100%;

  z-index: 1;
}
.devProject-content__laptop-video {
  position: absolute;
  top: 7%;
  left: 11.8%;

  width: 73%;
  height: 75.8%;

  object-fit: cover;
  object-position: top center;
}
.devProject-content__devices-animation-block {
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;

  z-index: 2;
}

.devProject-content-mob__wrapper {
  display: none;
}
@media (max-width: 1300px) {
  .devProject-content__container {
    padding: 0 20px;
  }
}

@media (max-width: 762px) {
  .devProject-content__container {
    display: none;
  }

  .devProject-content-mob__wrapper {
    position: relative;
    display: flex;
    justify-content: center;

    width: 100%;

    padding: 85px 0 100px 0;
  }
  .devProject-content-mob__br {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
  }
  .devProject-content-mob__container {
    position: relative;
    overflow: hidden;

    height: 346px;
  }

  .devProject-content-mob__phone-video {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;

    border-radius: 40px;
    padding: 0 2px;
  }
  .devProject-content-mob__phone {
    position: relative;
    z-index: 1;
  }
}
</style>
